const NAV_ITEMS = [
  {
    label: "Risk of Recurrence",
    path: "/adjuvant-renal-cell-carcinoma/risk-of-recurrence/",
  },
  {
    label: "Mechanisms of Action",
    path: "/adjuvant-renal-cell-carcinoma/mechanisms-of-action/",
    anchors: [
      { label: "MOA for KEYTRUDA & KEYTRUDA QLEX", id: "MOA-for-KEYTRUDA-&-KEYTRUDA-QLEX" },
      { label: "MOA for WELIREG", id: "MOA-for-WELIREG" }
    ],
  },
  {
    label: "Efficacy & Safety",
    path: "/adjuvant-renal-cell-carcinoma/efficacy-and-safety",
    anchors: [
      { label: "Efficacy", id: "Efficacy" },
      { label: "Study Design", id: "Study-Design" },
      { label: "Patient Population", id: "Patient-Population" },
      { label: "Safety", id: "Safety" },
    ],
  },
  {
    label: "Dosing & Administration",
    path: "/adjuvant-renal-cell-carcinoma/dosing-and-administration/",
    anchors: [
      { label: "Dosing for WELIREG", id: "Dosing-for-WELIREG" },
      { label: "Dose Modifications for WELIREG", id: "Dose-Modifications-for-WELIREG" },
      { label: "Dosing for KEYTRUDA or KEYTRUDA QLEX", id: "Dosing-for-KEYTRUDA-or-KEYTRUDA-QLEX" },
      { label: "Dose Modifications for KEYTRUDA", id: "Dose-Modifications-for-KEYTRUDA" },
      { label: "Dose Modifications for KEYTRUDA QLEX", id: "Dose-Modifications-for-KEYTRUDA-QLEX" },    
    ],
  },
  {
    label: "Resources & Ordering",
    path: "/adjuvant-renal-cell-carcinoma/resources-and-ordering/",
    anchors: [
      { label: "Dispensing & Ordering", id: "Dispensing-and-Ordering" },
      { label: "Connect with Merck", id: "Connect-With-Merck" },
    ],
  },
];

const multiHeaderCopy = {
    "mt" : {
        className: "home-welireg-header",
        bgImg: "/static/images/welireg-headerbg.png",
        bgImgTab: "/static/images/bgtablet.png",
        bgImgMob: "/static/images/bgmob.png",
        logos: [
                {
                    link: '/',
                    path:"/static/images/logos/welireg-logo-colour.svg",
                    pathMobileMenuOpened: "/static/images/logos/welireg-logo-white.svg",
                    alt:"WELIREG® (belzutifan) Logo",
                    className:"welireg-logo"
                }
            ],
            showPrimaryNav: false,
            useWhiteHamburger: true,
    },
    "default" : {
        className: "home-welireg-header",
        bgImg: "/static/images/welireg-header-bg.png",
        logos: [
                {
                    link: '/',
                    path:"/static/images/logos/welireg-logo-colour.svg",
                    pathMobileMenuOpened: "/static/images/logos/welireg-logo-white.svg",
                    alt:"",
                    className:"welireg-logo"
                }
            ],
            showPrimaryNav: false,
            useWhiteHamburger: false,
    },
     "rcc" : {
        className: "home-welireg-header",
        bgImg: "/static/images/welireg-header-bg.png",
        logos: [
                {
                    link: '/',
                    path:"/static/images/logos/welireg-logo-colour.svg",
                    pathMobileMenuOpened: "/static/images/logos/welireg-logo-white.svg",
                    alt:"",
                    className:"welireg-logo"
                }
            ],
            showPrimaryNav: false,
            useWhiteHamburger: false,
    },
     "vhl" : {
        className: "home-welireg-header",
        bgImg: "/static/images/welireg-header-bg.png",
        logos: [
                {
                    link: '/',
                    path:"/static/images/logos/welireg-logo-colour.svg",
                    pathMobileMenuOpened: "/static/images/logos/welireg-logo-white.svg",
                    alt:"",
                    className:"welireg-logo"
                }
            ],
            showPrimaryNav: false,
            useWhiteHamburger: false,
    },
     "ut" : {
        className: "home-welireg-header",
        bgImg: "/static/images/welireg-header-bg.png",
        bgImgTab: "/static/images/welireg-header-bg.png",
        bgImgMob: "/static/images/welireg-header-bg-mob-1.png",
        logos: [
                {
                    link: '/',
                    path:"/static/images/logos/welireg-logo-colour.svg",
                    pathMobileMenuOpened: "/static/images/logos/welireg-logo-white.svg",
                    alt:"",
                    className:"welireg-logo"
                }
            ],
            showPrimaryNav: false,
            useWhiteHamburger: true,
    },
    "arcc" : {
        className: "home-kwq-header",
         defaultVariant: "dual",
         logos: [
                {
                    link: '/adjuvant-renal-cell-carcinoma/',
                    path:"/static/images/logos/Key-Wel-Qlex_Horizontal_FINAL.svg",
                    pathMobileMenuOpened: "/static/images/logos/keytruda-welireg-logo-white.svg",
                    alt:"KEYTRUDA® (pembrolizumab) or KEYTRUDA QLEX™ (pembrolizumab and berahyaluronidase alfa-pmph) & WELIREG® (belzutifan) Logo",
                    className:"keytruda-qlex-logo"
                },
            ],
         variant:{
          dual:{
            bgImg: "/static/images/keytruda-welireg-qlex-header-bg.png",
          },
          tri:{
            bgImg: "/static/images/keytruda-welireg-qlex-nav.png",
          }
         },
         routeVariants: [
      {
        path: "/adjuvant-renal-cell-carcinoma/dosing-and-administration/",
        variant: "tri",
      },
    
    ],
        
        showPrimaryNav: true,
        useWhiteHamburger: false,
        navItems: NAV_ITEMS,
    },
    


}

export default multiHeaderCopy;